import{ButtonLargeTextStyle as d,ButtonRegularTextStyle as g,ButtonSmallTextStyle as h}from"../../typography/ButtonText/index.js";import{resolveColorWithNeutral as t,getDarkerShade as c,getLighterShade as s}from"../../utils/utils.js";import"react/jsx-runtime";import"styled-components";const m={small:h,regular:g,large:d},$=()=>`
  padding: 0.25rem 0.75rem;
  min-height: 2.5rem;
`,u=()=>`
  padding: 0.25rem 1.5rem;
  min-height: 3rem;
`,S=()=>`
  padding: 0.25rem 1.5rem;
  min-height: 3.75rem;
`,p=({theme:r,$color:l,$colorShade:e})=>{const o=t(r,l);return`
  color: ${r.colors.text.light};
  background-color: ${o[e]};

  &:hover {
    border-color: ${o[c(e)]};
    filter: brightness(0.9)
  }

  &:active {
    border-color: ${o[s(e)]};
    filter: brightness(1.1)
  }
`},b=({theme:r,$color:l,$colorShade:e})=>{const o=t(r,l),i=c(e),n=s(e);return`
  color: ${o[e]};
  border: 2px solid ${o[e]};
  background-color: transparent;

  &:hover {
      border: 2px solid ${o[i]};
      color: ${o[i]};
  }

  &:active {
    border: 2px solid ${o[n]};
    color: ${o[n]};
  }
`},y=({theme:r,$color:l,$colorShade:e})=>{const o=t(r,l);return`
  color: ${o[e]};

  background-color: transparent;

  &:hover, &:active {
    color: ${o[c(e)]};
  }
`},a=r=>`
  color: ${r.colors.grayscaleToned.light1};
  cursor: not-allowed;
`,x=(r,l)=>l==="solid"?`
    ${a(r)};
    background-color: ${r.colors.grayscaleToned.light4};`:l==="outline"?`
    ${a(r)};
    border: 2px solid ${r.colors.grayscaleToned.light1};`:a(r),v={solid:p,outline:b,flat:y};export{v as colorStyles,x as disabledColorStyles,m as fontSizes,S as largeSizeStyles,u as regularSizeStyles,$ as smallSizeStyles};
